import React, { useEffect, useState } from "react";
import { Mail, Send, Loader2, Check, Eye } from "lucide-react";
import { API } from "../api";

export default function AdminEmailPreview() {
  const [tpls, setTpls] = useState(null);
  const [sel, setSel] = useState(0);
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(null);

  useEffect(() => {
    fetch(`${API}/admin/email-templates`, { credentials: "include" })
      .then((r) => r.ok ? r.json() : Promise.reject()).then((d) => setTpls(d.templates || [])).catch(() => setTpls([]));
  }, []);

  const sendTests = async (onlyMe = false) => {
    setSending(true); setSent(null);
    try {
      const body = onlyMe
        ? JSON.stringify({ only: true, email: "seb.ollagnon@gmail.com" })
        : "{}";
      const r = await fetch(`${API}/admin/email-preview-all`, {
        method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body,
      });
      const d = await r.json();
      setSent(d);
    } catch (_) { setSent({ error: true }); }
    setSending(false);
  };

  if (!tpls) return <div className="py-16 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-[#C19A6B]" /></div>;
  const current = tpls[sel];

  return (
    <div className="space-y-5" data-testid="admin-email-preview">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="text-2xl font-bold tracking-tight text-[#111827] flex items-center gap-2"><Mail className="w-6 h-6 text-[#C19A6B]" /> Aperçu des e-mails</h2>
          <p className="text-sm text-zinc-500 mt-0.5">Prévisualisez chaque modèle avant envoi. {tpls.length} modèles.</p>
        </div>
        <div className="flex flex-wrap gap-2">
          <button onClick={() => sendTests(true)} disabled={sending} data-testid="admin-email-sendme"
            className="inline-flex items-center gap-2 bg-white border border-[#C19A6B] text-[#A88358] hover:bg-[#FBF7F1] text-xs font-bold uppercase tracking-wider rounded-[5px] px-4 py-2.5 disabled:opacity-50">
            {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Envoyer à moi seulement
          </button>
          <button onClick={() => sendTests(false)} disabled={sending} data-testid="admin-email-sendtests"
            className="inline-flex items-center gap-2 bg-[#C19A6B] hover:bg-[#A88358] text-white text-xs font-bold uppercase tracking-wider rounded-[5px] px-4 py-2.5 disabled:opacity-50">
            {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Vincent &amp; Seb
          </button>
        </div>
      </div>
      {sent && !sent.error && (
        <div className="flex items-center gap-2 text-sm text-emerald-600 bg-emerald-50 border border-emerald-200 rounded-[5px] px-3 py-2" data-testid="admin-email-sent">
          <Check className="w-4 h-4" /> {sent.sent} e-mails envoyés à {(sent.to || []).join(" et ")}.
        </div>
      )}

      <div className="grid lg:grid-cols-[280px_1fr] gap-4">
        <div className="rounded-xl border border-[#E5E7EB] bg-white p-2 max-h-[70vh] overflow-y-auto">
          {tpls.map((t, i) => (
            <button key={t.key} onClick={() => setSel(i)} data-testid={`admin-email-item-${i}`}
              className={`w-full text-left px-3 py-2.5 rounded-lg text-sm transition-colors flex items-center gap-2 ${i === sel ? "bg-[#C19A6B] text-white" : "text-[#374151] hover:bg-[#F1F3F5]"}`}>
              <Eye className={`w-3.5 h-3.5 ${i === sel ? "text-white" : "text-[#C19A6B]"}`} /> {t.label}
            </button>
          ))}
        </div>
        <div className="rounded-xl border border-[#E5E7EB] bg-white overflow-hidden">
          <div className="px-4 py-2.5 border-b border-[#F3F4F6] text-sm"><span className="text-zinc-500">Objet : </span><span className="font-semibold text-[#111827]">{current?.subject}</span></div>
          <iframe title="preview" srcDoc={current?.html} className="w-full" style={{ height: "68vh", border: "none", background: "#eef0f3" }} data-testid="admin-email-iframe" />
        </div>
      </div>
    </div>
  );
}
